import React from 'react';
import '../../styles/WhyChooseReventLabs.css';

interface WhyChooseReventLabsProps {
  industryName: string;
  description: string;
  benefits: string[];
}

const WhyChooseReventLabs: React.FC<WhyChooseReventLabsProps> = ({ industryName, description, benefits }) => {
  return (
    <section className="why-choose-section">
      <div className="why-choose-container">
        <div className="why-choose-header">
          <div className='why-choose-heading'>
            <p className="why-choose-title">
              Why Choose ReventLabs for 
            </p>
          </div>
          <div className='why-choose-subtitle'>
            <p className="highlight">{industryName}</p>
            <p className="why-choose-description">{description}</p>
          </div>
        </div>
        
        <div className="benefits-container">
          {benefits.map((benefit, index) => (
            <div 
            key={index} 
            className="benefits-container-card serviceList-card" 
        >
          <span className="benefits-container-card-number serviceList-card-number">
            {String(index + 1).padStart(2, '')}
          </span>
          <div className='benefits-container-card-text serviceList-card-content'>
              <p className='serviceList-desc'>{benefit}</p>
          </div>
        </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseReventLabs; 
